<template>
  <div class="vl-person-comp">
    <!--面包屑-->
    <div class="pm-bread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'personDefault' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'personDefault' }">我的应用</el-breadcrumb-item>
        <el-breadcrumb-item>组件管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
  export default {
    data() {
      return {

      }
    },
    mounted() {
    },
    methods: {},
  }
</script>
<style lang="scss" scoped>
  .vl-person-comp {
    width:1200px;
    position: relative;
    margin:0 auto;
    background: #FFFFFF;
    padding-top: 50px;
    min-height: 857px;
    .pm-bread {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 50px;
      @include setColor('background-color', 'chunk_3');
      display: flex;
      align-items: center;
    }
  }
</style>